import { render } from "./SeguiFormComp.vue?vue&type=template&id=66fa6890&scoped=true&ts=true"
import script from "./SeguiFormComp.vue?vue&type=script&lang=ts"
export * from "./SeguiFormComp.vue?vue&type=script&lang=ts"

import "./SeguiFormComp.vue?vue&type=style&index=0&id=66fa6890&lang=css&scoped=true"

import exportComponent from "C:\\Users\\Ronnald\\Desktop\\page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66fa6890"]])

export default __exports__